// ©2024 Austin App House. All rights reserved.
import React from 'react';
import {
  MDBCol, MDBIcon, MDBModal, MDBModalBody, MDBRow,
} from 'mdbreact';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
import ContractorBankingInformationReduxForm from '../layout/reduxForm/ContractorBankingInformation';
import ControlButtonsSection from '../layout/reduxForm/section/contractorBankingInformation/ControlButtonsSection';
import onSubmit from '../../utils/reduxForm/onSubmit/contractorBankingInformation';

const AddBankInfoForContractor = ({
  modalState,
  toggleModal,
}) => {
  const closeModal = () => {
    toggleModal(!modalState.isOpen, 'addBankInfoForContractor');
  };

  return modalState.isOpen ? (
    <div
      className="profile_container"
    >
      <div className="profile_inner opened">
        <div className='profile_head'>
          <div className="page_title">Banking Information</div>
          <button
            className="close_btn icon_close"
            aria-label="close"
            onClick={closeModal}
          ></button>
        </div>
        <div className="profile_head">
          <div className="font12">
            Tell us where you`d like to receive your payments
          </div>
        </div>
        <div className="profile_content">
          <ContractorBankingInformationReduxForm onSubmit={onSubmit} />
          <ControlButtonsSection closeModal={closeModal} />
        </div>
      </div>
    </div>
  ) : null;
};

const mapStateToProps = (state) => ({
  profile: state.profile,
  modalState: state.modalState.addBankInfoForContractor,
});

export default connect(mapStateToProps, {
  toggleModal,
})(AddBankInfoForContractor);
